var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { shadow } from '../theme/shadow';
import React from 'react';
import { animated } from '@react-spring/web';
import styled from 'styled-components';
import cx from 'classnames';
const StyledBox = styled(animated.div) `
  @apply rounded-md overflow-hidden;

  border: 1px solid var(--border-color);
  background-color: ${(props) => (props.transparent ? 'transparent' : 'var(--bg-color)')};
  padding: ${(props) => `${props.padding || 0}px`};
  box-shadow: ${(props) => {
    var _a, _b;
    if (props.borderless) {
        return undefined;
    }
    return props.shadow
        ? `${shadow[props.shadow]}, ${(_a = props.theme) === null || _a === void 0 ? void 0 : _a.shadow.outline}`
        : (_b = props.theme) === null || _b === void 0 ? void 0 : _b.shadow.outline;
}};
  display: ${(props) => props.display};
  align-items: ${(props) => props.alignItems};
`;
export const Box = React.forwardRef((_a, ref) => {
    var { children, style, className, borderless } = _a, props = __rest(_a, ["children", "style", "className", "borderless"]);
    return (React.createElement(StyledBox, Object.assign({ className: cx('box', className), ref: ref, "data-role": "box", borderless: borderless }, props, { style: style }), children));
});
Box.displayName = 'Box';
